import classNames from 'classnames';
import styles from './styles/EventListItemLoading.module.scss';

const EventListItemLoading = () => {

    const loadingContainerClassName = classNames({
        [styles.loadingContainer]: true,
    });

    return (
        <div className={loadingContainerClassName}>
            <div className={styles.dateBottom}/>
            <div className={styles.dateTop}/>
            <div className={styles.dateRight}/>
            <div className={styles.dateLeft} />

            <div className={styles.titleBottom} />
            <div className={styles.titleRight} />

            <div className={styles.contentRight} />
            <div className={styles.contentTop} />
            <div className={styles.contentMiddle} />
            <div className={styles.contentBottom} />

            <div className={styles.locationRight} />
        </div>
    )
};

export default EventListItemLoading;
